import React from "react";

function SubNavbarWrapper(props) {
  return <div className="sub-navbar">{props.children}</div>;
}

export default SubNavbarWrapper;
